import { route, settingsSig, onlineSig, toastSig } from './state';
import { aiMonthSig } from '../ai/client';
import { JobsView } from './views/JobsView';
import { ClientsView } from './views/ClientsView';
import { JobView } from './views/JobView';
import { DocView } from './views/DocView';
import { FieldView } from './views/FieldView';
import { PricesView } from './views/PricesView';
import { SettingsView } from './views/SettingsView';
import { BackupView } from './views/BackupView';

export function App() {
  const r = route.value;
  const s = settingsSig.value;
  const backed = s?.lastSnapshotAt ? timeAgo(s.lastSnapshotAt) : 'not yet';
  const exported = s?.lastExportAt ? timeAgo(s.lastExportAt) : 'never';

  if (r.view === 'field') {
    return (
      <main class="page" style="padding-top:24px;">
        {r.id && <FieldView jobId={r.id} />}
        {toastSig.value && <div class="toast" role="status">{toastSig.value}</div>}
      </main>
    );
  }
  return (
    <div>
      <header class="topbar">
        <a class="brand" href="#/">FOREVER GREEN · BID STUDIO</a>
        <nav class="topnav" aria-label="Main">
          <a href="#/" class={r.view === 'jobs' || r.view === 'job' ? 'on' : ''}>Jobs</a>
          <a href="#/clients" class={r.view === 'clients' ? 'on' : ''}>Clients</a>
          <a href="#/prices" class={r.view === 'prices' ? 'on' : ''}>Prices</a>
          <a href="#/backup" class={r.view === 'backup' ? 'on' : ''}>Backup</a>
          <a href="#/settings" class={r.view === 'settings' ? 'on' : ''}>Settings</a>
        </nav>
        <div class="statuschips">
          {aiMonthSig.value && (
            <span class={`chip ${aiMonthSig.value.status === 'ok' ? '' : aiMonthSig.value.status === 'warn' ? 'chip-warn' : 'chip-err'}`}
              title="AI spend this month against the server-enforced cap">
              <b>AI</b> ${aiMonthSig.value.spentUsd.toFixed(2)} / ${aiMonthSig.value.capUsd.toFixed(0)}
            </span>
          )}
          <span class="chip" title="Automatic snapshot on this device / your exported backup file">
            <b>Backed up</b> {backed} · <b>exported</b> {exported}
          </span>
          <span class={`chip ${onlineSig.value ? 'chip-ok' : 'chip-warn'}`}>
            {onlineSig.value ? '● Online' : '● Offline — edits stay on this device'}
          </span>
        </div>
      </header>

      <main class="page">
        {r.view === 'jobs' && <JobsView />}
        {r.view === 'job' && r.id && !r.sub && <JobView jobId={r.id} />}
        {r.view === 'job' && r.id && r.sub && <DocView jobId={r.id} docId={r.sub} />}
        {r.view === 'clients' && <ClientsView />}
        {r.view === 'prices' && <PricesView />}
        {r.view === 'settings' && <SettingsView />}
        {r.view === 'backup' && <BackupView />}
      </main>

      {toastSig.value && <div class="toast" role="status">{toastSig.value}</div>}
    </div>
  );
}

function timeAgo(iso: string): string {
  const s = Math.max(0, (Date.now() - Date.parse(iso)) / 1000);
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s / 60)} min ago`;
  if (s < 86400) return `${Math.floor(s / 3600)} h ago`;
  return `${Math.floor(s / 86400)} d ago`;
}
